module.exports = __webpack_public_path__ + "img/DSC09065-scaled-1-1024x683 img1.d54cb7a1.jpg";